/* eslint-disable import/no-anonymous-default-export */
import apiCall from "./apiCall";

export default {

    async getReports(data) {
      const response = apiCall("report/list", data);
      return response
    },

    async createReport(data) {
      const response = apiCall("report/create", data);
      return response
    },

    async generateReport(data) {
      const response = apiCall("exam/reports/report/load_reports", data);
      return response
    },

    async listReportCommentConfig() {

        const response = await apiCall("report/conf/comments/list", []);
        return response;

      },

      async getReportComments(reportId) {

        let data={
          "report_id":reportId
        }

        const response = apiCall("report/comments/list", data);
        return response
        
      },

      async addReportComment(report_id, comment_id) {

        let data={
          "report_id":report_id,
          "comment_id":comment_id
        }

        const response = apiCall("report/comments/add", data);
        return response
      },

      async writeReportComment(report_id, comment_id, student_id, comment) {

        let data={
          "report_id":report_id,
          "comment_id":comment_id,
          "comment_value":comment,
          "student_id":student_id
        }
        const response = apiCall("report/comment/write", data);
        return response
      },

      async writeGeneralReportComment(field_id, comment) {

        let data={
          "field_id":field_id,
          "comment_value":comment,
        }
        const response = apiCall("report/comment/general/write", data);
        return response
      },

      async deleteReportCommentField(field_id) {

        let data={
          "field_id":field_id
        }
        const response = apiCall("report/comment/delete", data);
        return response
        
      },
      
      async getCurrentReports() {
        const response = apiCall("report/comment/delete", []);
        return response
      
      },

      async generateMarksheet(data) {
        const response = apiCall("mark/marksheet", data);
        return response
      },


      async updateReport(data) {
        const response = apiCall("report/update", data);
        return response
      },


      async addReportInitials(report_id, teacher_id, paper_id) {

        let data={
          "report_id":report_id,
          "teacher_id":teacher_id,
          "paper_id" : paper_id
        }
        const response = apiCall("report/initials/add", data);
        return response
        
      },


      async callCountAllReports(data){
         const response = apiCall("report/count/all", data);
         return response
      },

      async callCountCurrentReports(data){
        const response = apiCall("report/count/current", data);
        return response
     },

     async fetchStudentReports(data){
      const response = apiCall("report/student/list", data);
      return response
    },

    async configureNewComment(data){
      const response = apiCall("report/config/comment", data);
      return response
    },

    async configUpdateComment(data){
      const response = apiCall("report/config/comment/update", data);
      return response
    },

    async syncSchoolFees(classId){
      const response = apiCall("student/balance/sync", {class_id:classId});
      return response
    },


    async addCommentStaff(reportCommentId, staffId){
      const response = apiCall("report/comment/staff/update", {report_comment_id:reportCommentId, staff_id:staffId});
      return response
    },

    async loadStudentReport(data){
      const response = apiCall("exam/reports/report/load_student_report", data);
      return response
    },
    async toggleReportAutoComment(reportId, autoComment) {
      const response = apiCall("exam/reports/report/set_auto_comment", { report_id: reportId, auto_comment: autoComment });
      return response
    },
}